module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAdCAYAAAAgqdWEAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAElSURBVHgB7ZbRbcJAEETHKP+hg1wHSQkpISW4g9ABdAAdmA6ACoAKoAO7BDpYdiWQEGLXvgEkEDxpv04zntv12Qc8CyIy0xrihpif1lirnyMywZFKK+FK1OP/xLPu5HlIf46Jf0BiWrnMIBL9SsyACJIOm/GYMCJbS8hENVOJ+WNE2WNSTdniOYLTlTxRtzB14Fl5oqgrSxC0dKWWSyPv0JUEAom7UnqiSSCqyCDRqawj4UZu35Up05VoRNS7wm6wpxUd1wW4IP3Ad1UURQMizBYckefaW/hoEX47LZ3r7nbgwnw578zKWrqUfFLwMPMcST6ljSk0Jkkg6OGBuFeY7re4E+4V5hMELzEmincYj3cYj4cKYz9Kuybkfhd2Levm2SCPZg8TJz8113NHDwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/quote2.png
// module id = PFwi
// module chunks = 1